import { Undefinedable } from 'app/constants/types';
import {
  getIpAddressFromStorage,
  getCountryFromStorage,
} from 'app/helpers/local-storage';
import {
  BuyTokenPackagePayload,
  BuyTokenPackageResponse,
  GetTokenPackagesPayload,
  GetTokenPackagesResponse,
  UnSribeSubscriptionPayload,
} from 'app/pages/Services/slice/types';
import axiosService from 'app/services/axios.service';
import { path } from 'ramda';

const PACKAGE_BASE_URL = '/v1/packages';

export const getTokenPackages = async (
  payload: GetTokenPackagesPayload,
): Promise<Undefinedable<GetTokenPackagesResponse>> => {
  const queryParams = '_sort=price@asc';

  const response = await axiosService.get(`${PACKAGE_BASE_URL}?${queryParams}`);
  return path(['data'], response);
};

export const buyTokenPackage = async (
  payload: BuyTokenPackagePayload,
): Promise<Undefinedable<BuyTokenPackageResponse>> => {
  const { packageId, ipAddress, country, subscriptionID } = payload;
  const response = await axiosService.post(
    `${PACKAGE_BASE_URL}/${packageId}/buy`,
    {
      ipAddress:
        typeof ipAddress === 'string' ? ipAddress : getIpAddressFromStorage(),
      country: typeof country === 'string' ? country : getCountryFromStorage(),
      subscriptionID,
    },
  );
  return path(['data', 'data'], response);
};

export const unsubscribeSubscription = async (
  payload: UnSribeSubscriptionPayload,
) => {
  const { packageId } = payload;

  const response = await axiosService.post(`${PACKAGE_BASE_URL}/unSubscribe`, {
    packageId,
  });
  return path(['data', 'data'], response);
};

export const createSubscription = async planId => {
  const response = await axiosService.post(
    `${PACKAGE_BASE_URL}/create-subscription`,
    { planId, ipAddress: getIpAddressFromStorage() },
  );
  return path(['data'], response);
};

export const completeSubscription = async subscriptionId => {
  const response = await axiosService.post(
    `${PACKAGE_BASE_URL}/complete-subscription`,
    {
      ipAddress: getIpAddressFromStorage(),
      country: getCountryFromStorage(),
      subscriptionId,
    },
  );
  return path(['data', 'data'], response);
};
